import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface BrandMarkProps extends SVGProps<SVGSVGElement> {
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
} as const;

export function BrandMark({ className, size = 'md', ...props }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-label="Mindhunters brand mark"
      role="img"
      className={cn(sizeMap[size], 'text-[var(--text-primary)]', className)}
      {...props}
    >
      <circle cx="8" cy="8" r="3" fill="currentColor" opacity="0.92" style={{ animation: "dotShimmer 3s ease-in-out infinite 0s" }} />
      <circle cx="16" cy="8" r="3" fill="currentColor" opacity="0.84" style={{ animation: "dotShimmer 3s ease-in-out infinite 0.5s" }} />
      <circle cx="12" cy="15.5" r="3" fill="currentColor" opacity="0.76" style={{ animation: "dotShimmer 3s ease-in-out infinite 1s" }} />
    </svg>
  );
}
